import { useRef, useState } from 'react';
import './OnboardingPage.css';

const SLIDES = [
  {
    emoji: '🌳',
    title: '인생로그에 오신 걸 환영해요!',
    desc: '나의 인생을 기록하는 타임라인 앱입니다',
  },
  {
    emoji: '➕',
    title: '첫 기록을 추가해보세요',
    desc: '오른쪽 하단 + 버튼을 눌러\n기록을 추가할 수 있어요',
    fab: true,
  },
  {
    emoji: '📂',
    title: '카테고리를 선택해요',
    desc: '거주지, 직장, 여행 등\n다양한 카테고리로 기록을 분류해요',
    categories: true,
  },
  {
    emoji: '📍',
    title: '위치와 사진도 남겨요',
    desc: '기록한 장소를 지도에서 확인하고\n사진도 첨부할 수 있어요',
  },
  {
    emoji: '👶',
    title: '자녀의 성장을 기록해요',
    desc: '자녀 프로필로 태어난 순간부터 성장과정을\n모두❤️ 기록해보세요!',
    descSub: [
      '아이가 자라면 프로필 승계 기능으로\n소중한 기록을 모두 전달할 수 있어요!',
      '부모님이 기록한 수천 개의 추억이\n아이에게 평생의 선물이 됩니다.',
    ],
    isLast: true,
  },
];

const CATEGORY_ICONS = [
  { emoji: '🏠', label: '거주지' },
  { emoji: '💼', label: '직장' },
  { emoji: '✈️', label: '여행' },
  { emoji: '🎓', label: '학교' },
  { emoji: '💕', label: '연애' },
  { emoji: '🏥', label: '건강' },
  { emoji: '🎉', label: '이벤트' },
  { emoji: '📝', label: '기타' },
];

export default function OnboardingPage({ onDone }) {
  const [current, setCurrent] = useState(0);
  const touchStartX = useRef(0);
  const touchStartY = useRef(0);

  const goNext = () => {
    if (current < SLIDES.length - 1) setCurrent(current + 1);
  };

  const goPrev = () => {
    if (current > 0) setCurrent(current - 1);
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  };

  const handleTouchEnd = (e) => {
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    const dy = e.changedTouches[0].clientY - touchStartY.current;
    // 수평 스와이프만 처리 (수직 스크롤 무시)
    if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy)) return;
    if (dx < 0) goNext();
    else goPrev();
  };

  const slide = SLIDES[current];

  return (
    <div className="onboarding">
      <div className="ob-top-bar">
        {!slide.isLast && (
          <button className="ob-skip" onClick={onDone}>건너뛰기</button>
        )}
      </div>

      <div
        className="ob-slides-viewport"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <div
          className="ob-slides-track"
          style={{ transform: `translateX(-${current * 100}%)` }}
        >
          {SLIDES.map((s, i) => (
            <div key={i} className="ob-slide">
              <span className="ob-emoji">{s.emoji}</span>
              <h2 className="ob-title">{s.title}</h2>
              <p className="ob-desc">{s.desc}</p>

              {s.descSub && s.descSub.map((text, j) => (
                <p key={j} className="ob-desc-sub">{text}</p>
              ))}

              {s.fab && (
                <div className="ob-fab-demo">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                </div>
              )}

              {s.categories && (
                <div className="ob-cat-grid">
                  {CATEGORY_ICONS.map((cat) => (
                    <div key={cat.label} className="ob-cat-item">
                      <div className="ob-cat-icon">{cat.emoji}</div>
                      <span className="ob-cat-label">{cat.label}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="ob-bottom">
        <div className="ob-dots">
          {SLIDES.map((_, i) => (
            <div
              key={i}
              className={`ob-dot${i === current ? ' ob-dot--active' : ''}`}
            />
          ))}
        </div>

        {slide.isLast ? (
          <button className="ob-btn ob-btn--start" onClick={onDone}>
            시작하기
          </button>
        ) : (
          <button className="ob-btn ob-btn--next" onClick={goNext}>
            다음
          </button>
        )}
      </div>
    </div>
  );
}
